import { StreamActions } from "@hotwired/turbo"

StreamActions.hide = function hide() {
  this.targetElements.forEach(el => { el.hidden = true })
}

StreamActions.show = function show() {
  this.targetElements.forEach(el => { el.hidden = false })
}

StreamActions.dispatch = function() {
  const eventName = this.getAttribute("event")

  this.targetElements.forEach(el => {
    el.dispatchEvent(new CustomEvent(eventName, { bubbles: true }))
  })
}
